import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["type"];
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { UnifiedRoutingOwnerNames } from 'automation-ui-action-features/actions/rotate-object/UnifiedRoutingOwnerNames';
import { useUnifiedRoutingExplainerMessage } from 'automation-ui-action-features/actions/rotate-object/hooks/useUnifiedRoutingExplainerMessage';
import ObjectTypeName from 'automation-ui-references/object-types/ObjectTypeName';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const UnifiedRoutingContactOwnerExplainer = ({
  objectTypeId,
  routingRuleDefinition
}) => {
  const _useUnifiedRoutingExp = useUnifiedRoutingExplainerMessage(routingRuleDefinition),
    {
      type
    } = _useUnifiedRoutingExp,
    messageOptions = _objectWithoutPropertiesLoose(_useUnifiedRoutingExp, _excluded);
  if (type === '') {
    return /*#__PURE__*/_jsx(FormattedJSXMessage, {
      elements: {
        ObjectTypeName
      },
      message: "automation-ui-action-features.action-features.rotate-object.unified-routing.explainer.contact-owner.no-one_jsx",
      options: {
        objectTypeId
      }
    });
  }
  const getFallbackMessage = () => {
    const elements = {
      ObjectTypeName,
      UnifiedRoutingOwnerNames
    };
    const options = Object.assign({}, messageOptions, {
      objectTypeId
    });
    switch (type) {
      case 'teams-only':
        return /*#__PURE__*/_jsx(FormattedJSXMessage, {
          elements: elements,
          message: "automation-ui-action-features.action-features.rotate-object.unified-routing.explainer.contact-owner.teams-only_jsx",
          options: options
        });
      case 'users-only':
        return /*#__PURE__*/_jsx(FormattedJSXMessage, {
          elements: elements,
          message: "automation-ui-action-features.action-features.rotate-object.unified-routing.explainer.contact-owner.users-only_jsx",
          options: options
        });
      case 'users-and-teams':
        return /*#__PURE__*/_jsx(FormattedJSXMessage, {
          elements: elements,
          message: "automation-ui-action-features.action-features.rotate-object.unified-routing.explainer.contact-owner.users-and-teams_jsx",
          options: options
        });
      default:
        return null;
    }
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(FormattedJSXMessage, {
      elements: {
        ObjectTypeName
      },
      message: "automation-ui-action-features.action-features.rotate-object.unified-routing.explainer.contact-owner.base_jsx",
      options: {
        objectTypeId
      }
    }), getFallbackMessage()]
  });
};
UnifiedRoutingContactOwnerExplainer.displayName = 'UnifiedRoutingContactOwnerExplainer';